import {
  SupportInboundTicketCategory,
  SupportOutboundTicketCategory,
  SupportTicketCategory,
} from './general-types/support-ticket';

export const SUPPORT_TICKET_CATEGORY_OPTIONS: {
  value: SupportInboundTicketCategory;
  label: string;
}[] = [
  { value: 'bug_report', label: 'Bug report' },
  { value: 'feature_request', label: 'Feature request' },
  { value: 'support_question', label: 'Support question' },
  { value: 'blank_issue', label: 'Something else?' },
];

export const SUPPORT_OUTBOUND_TICKET_CATEGORY_OPTIONS: {
  value: SupportOutboundTicketCategory;
  label: string;
}[] = [
  { value: 'outreach', label: 'Outreach' },
  { value: 'payouts', label: 'Payouts' },
  { value: 'account', label: 'Account' },
  { value: 'campaign', label: 'Campaign' },
];

export function supportTicketCategoryLabel(
  category: SupportTicketCategory | null | undefined,
): string {
  if (!category) {
    return '—';
  }

  return (
    SUPPORT_TICKET_CATEGORY_OPTIONS.find((option) => option.value === category)?.label ??
    SUPPORT_OUTBOUND_TICKET_CATEGORY_OPTIONS.find((option) => option.value === category)?.label ??
    category
  );
}
